<div class="image-container" [style.min-height]="minHeight()">
  <div class="position-relative"
       [style.height]="height()"
       [style.width]="width()"
       [ngClass]="isLoading ? loadingContainerClass() : customContainerClass()">

    <div *loading="isLoading; class: loadingClass()"></div>

    <img #image
         alt="image"
         [attr.loading]="'lazy'"
         decoding="async"
         [ngClass]="[customClass(), 'image-component']"
         [class.image--loading]="isLoading"
         [style.opacity]="isLoading ? '0' : '1'">
  </div>
</div>
